import { Constants } from "./constants";

export const ResultTypesMap = new Map<string, string>([
  [Constants.score_result_type.absent, "ABS"],
  [Constants.score_result_type.excused, "EX"],
  [Constants.score_result_type.disqualified, "DQ"],
  [Constants.score_result_type.not_qualified, "NQ"],
]);
